module.exports = __webpack_public_path__ + "img/im_meal@2x.41980ecc.jpg";